export default __webpack_public_path__ + "static/Artificial_Light_Indoor_1280kbps-b9fbe09cd6e7b0c5faede3bef0b4d671.avif";